module.exports = __webpack_public_path__ + "img/onekey__hotels__english.c9b6e239.svg";